module.exports = __webpack_public_path__ + "img/logo-new.cb96fe17.svg";